export const UploadIconGray = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#646363"
      d="m8 8.39 2.829 2.829-.944.943-1.218-1.219v3.724H7.333v-3.725l-1.218 1.22-.944-.943L8 8.39Zm0-7.057a4.667 4.667 0 0 1 4.636 4.13 3.667 3.667 0 0 1-.635 7.19v-1.344a2.332 2.332 0 0 0 1.65-3.542 2.335 2.335 0 0 0-2.392-1.064 3.335 3.335 0 0 0-5.851-2.795 3.333 3.333 0 0 0-.667 2.795 2.333 2.333 0 0 0-.86 4.587l.12.02v1.342a3.667 3.667 0 0 1-.637-7.19A4.667 4.667 0 0 1 8 1.335Z"
    />
  </svg>
);
